{
  "en": {
    "milestone": {
      "actions": {
        "activate": "Activate",
        "active": "Active!",
        "create": "Create milestone",
        "deactivate": "Deactivate",
        "delete": "Delete",
        "delete_milestones": "Delete milestone | Delete {count} milestones",
        "new": "Milestone"
      },
      "labels": {
        "bulk_assign_title": "Select units you want to assign milestone '{milestone_name}' to",
        "edit_units": "Edit units",
        "empty_state_subtitle": "Milestones make the building process more transparent for homebuyers",
        "empty_state_title": "Create a new milestone",
        "future_milestones": "Future milestones",
        "milestone": "Milestone",
        "milestone_name": "Milestone name",
        "milestone_unit_count": "0 units | 1 unit | {count} units",
        "milestones": "Milestones",
        "new_milestone": "New milestone",
        "no_milestone": "No milestone assigned yet",
        "no_results": "No milestones found",
        "past_milestones": "Past milestones",
        "please_select": "Please select a new milestone",
        "position": "Position",
        "search_empty_state": "No milestones created yet. Click here to start",
        "units": "Units",
        "units_without_milestone": "1 unit without milestone | {count} units without milestone",
        "warning_delete": "If you delete a milestone that has been assigned to a unit, the customer will lose sight of what milestone their unit is at. Be sure to assign a new milestone to these units!"
      },
      "toasts": {
        "bulk_assigned": "The milestone is successfuly assigned to the selected units",
        "create_success": "Milestone successfully created",
        "deactivate_success": "Milestone has been successfully deactivated",
        "sup_assigned": "The milestone is successfuly activated",
        "update_success": "Milestones have been successfully updated"
      },
      "validation": {
        "needName": "Name required"
      }
    }
  }
}